/** 运费计算 **/
<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >在线文档</span>
      <!-- <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >测试工具</span> -->
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'spmComCost/getComCost';
export default {
  components: { onlineDoc , apiTestDoc },
  data() { 
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: "通过收寄件地址及物品信息预估运费",
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: "接入方在平台的api账户标识"},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: "签名字符串"},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: "时间戳，毫秒"}
                    ]
            },
             { 
                title:'请求参数', 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
                ]
            },
            {
              title:"业务参数",
              value:[
                {name: "customerCode",type: "String(30)",require: "Y",normal: "J0086474299",describe: "客户编码（联系出货网点提供）"},
                {name: "digest",type: "String(50)",require: "Y",normal: "明文密码:H5CD3zE6",describe: "签名，Base64(Md5(客户编号+密文+privateKey))，其中密文：MD5(明文密码+jadada236t2) 后大写"},
                {name: "sender",type: "Object",require: "Y",normal: "",describe: "寄件信息对象"},
                {name: "receiver",type: "Object",require: "Y",normal: "",describe: "收件信息对象"},
                {name: "length",type: "int(6)",require: "N",normal: "",describe: "长，cm编号"},
                {name: "width",type: "int(6)",require: "N",normal: "",describe: "宽，cm"},
                {name: "height",type: "int(6)",require: "N",normal: "",describe: "高，cm"},
                {name: "weight",type: "String(12)",require: "Y",normal: "0.02",describe: "重量（正数），单位kg，范围0.01-30，为空默认0.02"}
              ]
            },
            {
              title:"sender类型说明",
              value:[
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe: "寄件省份"},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe: "寄件城市"},
                {name: "area",type: "String(32)",require: "Y",normal: "",describe: "寄件城区域"},
                {name: "town",type: "String(32)",require: "N",normal: "",describe: "寄件乡镇"},
                {name: "street",type: "String(32)",require: "N",normal: "",describe: "寄件街道"},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe: "寄件详细地址（省+市+区县+详细地址）"},
              ]
            },
            {
              title:"receiver类型说明",
              value:[
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe: "收件省份"},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe: "收件城市"},
                {name: "area",type: "String(32)",require: "Y",normal: "",describe: "收件城区域"},
                {name: "town",type: "String(32)",require: "N",normal: "",describe: "收件乡镇"},
                {name: "street",type: "String(32)",require: "N",normal: "",describe: "收件街道"},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe: "收件详细地址（省+市+区县+详细地址）"},
              ]
            },

        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:'响应参数',
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: "返回码，见附录",},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: "描述",},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: "业务数据",},
                    {name: "totalPrice",type: "String",require: "Y",normal: "",describe: "运费总价（单位：元），保留两位小数",},
                  ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent= {"receiver": {"area": "鼓楼区", "address": "中检大厦测试订单", "city": "南京市", "town": "", "street": "", "prov": "江苏"}, "sender": {"area": "鼓楼区", "address": "中检大厦测试订单", "city": "南京市", "town": "", "street": "", "prov": "江苏"}, "length": 10, "width": 10, "height": 10, "weight": 3.2, "digest": "JfuEJ9U4nZvh6Sx+7sxzkQ==", "customerCode": "J0086023910"}`,
        //返回示例
        responseCode: JSON.parse(`{
    "code": "1",
    "msg": "success",
    "data": {
      "totalPrice":4.5
    }
}`),

        //错误代码提示
        errcodeJson: [
          {code:'145003031',msg:"业务参数签名失败"},
          {code:'145003083',msg:"发件人信息不全"},
          {code:'145003084',msg:"收件人信息不全"},
          {code:'145003092',msg:"重量信息不合法"},
          {code:'145003080',msg:"客户未找到"},
          {code:'145003065',msg:"省市区地址不合法"}
        ]
      },

      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{"receiver": {"area": "鼓楼区", "address": "中检大厦测试订单", "city": "南京市", "town": "", "street": "", "prov": "江苏"}, "sender": {"area": "鼓楼区", "address": "中检大厦测试订单", "city": "南京市", "town": "", "street": "", "prov": "江苏"}, "length": 10, "width": 10, "height": 10, "weight": 3.2, "digest": "JfuEJ9U4nZvh6Sx+7sxzkQ==", "customerCode": "J0086023910"}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: [
          {code:'145003031',msg:"业务参数签名失败"},
          {code:'145003083',msg:"发件人信息不全"},
          {code:'145003084',msg:"收件人信息不全"},
          {code:'145003092',msg:"重量信息不合法"},
          {code:'145003080',msg:"客户未找到"},
          {code:'145003065',msg:"省市区地址不合法"}
        ]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>